module.exports = __webpack_public_path__ + "static/spinning-5b452ae424c8d360f8b64cb055b03371.png";